/**
 * Customized Dropdown Menu component.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma Reference: https://www.figma.com/file/Z8kfGR6BNKMm3XvQGhKcBD/PINS-Advantage-2021-Design-System?node-id=5%3A3
 */

import colors from '../foundation/colors';

const menuBaseStyle = {
  borderRadius: 'md',
  _focus: {
    outline: 'none',
    boxShadow: 'none'
  }
};

export const menuButtonBaseStyle = {
  textAlign: 'left',
  textStyle: 'bodyMd',
  borderRadius: 'md',
  padding: '10px 14px',
  textTransform: 'capitalize',
  _focus: {
    outline: 'none',
    boxShadow: 'none'
  },
  _active: {
    color: 'primaryScale.600',
    boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`,
    _hover: {
      color: 'primaryScale.600',
      boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`
    }
  },
  _disabled: { opacity: 0.5 }
};

const menuListBaseStyle = {
  boxShadow: 'hover',
  color: 'greyScale.600',
  padding: '10px',
  maxH: '300px',
  overflowY: 'auto',
  zIndex: '100',
  border: 'none'
};

export const menuItemBaseStyle = {
  borderRadius: 'md',
  textStyle: 'bodyMd500',
  height: '40px',
  textTransform: 'capitalize',
  color: 'greyScale.600',
  _hover: {
    bg: 'rgba(0, 140, 255, 0.1)',
    color: 'primaryScale.600',
    borderRadius: 'md'
  },
  _selected: {
    bg: 'white',
    color: 'primaryScale.600',
    fontWeight: 'semibold'
  },
  _focus: {
    outline: 'none',
    boxShadow: 'none',
    bg: 'rgba(0, 140, 255, 0.1)',
    color: 'primaryScale.600',
    borderRadius: 'md'
  }
};

const Menu = {
  parts: ['menu', 'button', 'list', 'item'],
  baseStyle: {
    menu: menuBaseStyle,
    button: menuButtonBaseStyle,
    list: menuListBaseStyle,
    item: menuItemBaseStyle
  },
  sizes: {
    md: {
      button: {
        height: '40px',
        fontSize: 'sm',
        fontWeight: 'normal'
      }
    },
    lg: {
      button: {
        height: '48px',
        fontSize: 'sm',
        fontWeight: 'normal'
      }
    }
  },
  variants: {
    primary: {
      button: {
        bg: 'greyScale.100',
        color: 'greyScale.500',
        _hover: {
          bg: 'greyScale.100',
          color: 'greyScale.500'
        }
      }
    },
    secondary: {
      button: {
        bg: 'primaryScale.50',
        color: 'primaryScale.600',
        fontWeight: '500',
        _hover: {
          bg: 'primaryScale.50',
          color: 'primaryScale.600'
        }
      }
    },
    accent: {
      button: {
        bg: 'greyScale.300',
        color: 'greyScale.700',
        fontWeight: 'medium'
      },
      _hover: {
        bg: 'greyScale.400',
        color: 'greyScale.500'
      }
    }
  },
  defaultProps: {
    variant: 'primary',
    size: 'md'
  }
};

export default Menu;
